import {
  CheckCircleIcon,
  ExclamationTriangleIcon,
  XCircleIcon,
  InformationCircleIcon,
} from "@heroicons/react/24/solid";
import clsx from "clsx";

import { Toast } from "@/utils/toast";

const ICON_MAP = {
  success: (
    <CheckCircleIcon className="h-5 w-5 text-emerald-600 dark:text-emerald-400" />
  ),
  error: <XCircleIcon className="h-5 w-5 text-red-600 dark:text-red-400" />,
  warning: (
    <ExclamationTriangleIcon className="h-5 w-5 text-amber-600 dark:text-amber-400" />
  ),
  info: (
    <InformationCircleIcon className="h-5 w-5 text-blue-600 dark:text-blue-400" />
  ),
};

const STYLE_MAP = {
  success:
    "bg-emerald-50 dark:bg-emerald-950/50 text-emerald-900 dark:text-emerald-100 ring-emerald-600/20 dark:ring-emerald-400/20",
  error:
    "bg-red-50 dark:bg-red-950/50 text-red-900 dark:text-red-100 ring-red-600/20 dark:ring-red-400/20",
  warning:
    "bg-amber-50 dark:bg-amber-950/50 text-amber-900 dark:text-amber-100 ring-amber-600/20 dark:ring-amber-400/20",
  info: "bg-blue-50 dark:bg-blue-950/50 text-blue-900 dark:text-blue-100 ring-blue-600/20 dark:ring-blue-400/20",
};

export default function ToastAlert({ message, type }: Toast) {
  return (
    <>
      <style>{`
        @keyframes toast-slide-in {
          from {
            opacity: 0;
            transform: translateY(-1rem);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        .toast-animate {
          animation: toast-slide-in 0.3s ease-out;
        }
      `}</style>
      <div
        className={clsx(
          "toast-animate fixed top-20 right-6 z-[100] px-4 py-3 rounded-xl shadow-lg ring-1 backdrop-blur-sm flex items-center gap-3 text-sm font-medium max-w-md",
          STYLE_MAP[type]
        )}
      >
        <div className="flex-shrink-0">{ICON_MAP[type]}</div>
        <span className="flex-1">{message}</span>
      </div>
    </>
  );
}
